// extracted by mini-css-extract-plugin
module.exports = {"loader":"Invoice_loader__2MaMI","load3":"Invoice_load3__1E1eO"};